export const messages = Object.freeze({
    delete_distributed_instance: "Distributed instances can't be deleted.",
    delete_master_instance: "The master instance can't be deleted.",
    empty_target_iids: 'Please select at least one target instance.',
    feature_disabled: 'This feature is disabled.',
    iid_is_none: 'A required instance value is missing from the request.',
    iids_required: 'Instances is required.',
    instance_currently_archived: 'The instance currently has been archived.',
    invalid_instance_short_id: 'Invalid instance short ID. Please check your input and try again.',
    invalid_snapshot_type: 'Invalid snapshot type. Please check your input and try again.',
    long_id_taken: 'This identifier is already in use.',
    missing_snapshots: 'Required snapshots is missing.',
    short_id_taken: 'This short name is already in use. Please choose another one.',
    snapshot_files_folder_exists: 'This snapshot files folder already exists.',
    snapshot_home_folder_exists: 'This snapshot home folder already exists.',
    snapshot_lib_folder_exists: 'This snapshot lib folder already exists.',
    space_deleted_prefix: 'This space has been deleted.',
    space_filesystem_prefix_missing: 'The file operation could not be completed. Please try again or contact support.',
    wait_for_instance_timeout: 'The wait for instance operation timed out. Please try again.'
})

export const dialogs = Object.freeze({
    quick_detailed_snapshot_limit_reached: {
        dialogTitle: 'Snapshot limit reached',
        dialogText:
            'You have reached the maximum number of on-demand snapshots. Please delete snapshots that are no longer needed. Auto snapshots do not count against the limit.',
        dialogAction: ['dismiss']
    },
    snapshot_rate_limit_error: {
        dialogTitle: "Can't create new snapshot!",
        dialogText: 'A snapshot is already being created, please wait for it to finish. You can check your task manager for running tasks.',
        dialogAction: ['close']
    }
})
